import styled from '@emotion/styled';
import { rgba } from 'polished';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const ModifyingDiv = styled.div(() =>
  mq({
    background: rgba(defaultTheme.background.primary, 0.1),
    color: defaultTheme.color.primary,
    fontSize: defaultTheme.font.size.xs,
    fontWeight: 'bold',
    textAlign: 'center',
    width: '100%',
    padding: defaultTheme.spacing.m,
    margin: `${defaultTheme.spacing.l} 0`,
  }),
);
